import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20silk%20fabric%20in%20warm%20peach%20and%20soft%20olive%20tones%20draped%20elegantly%20with%20gentle%20light%20gradients%2C%20modern%20minimalist%20editorial%20style%2C%20clean%20ethereal%20composition%20with%20subtle%20texture%2C%20no%20text%2C%20diffused%20warm%20lighting%20from%20above%2C%20sophisticated%20high-end%20aesthetic%20perfect%20for%20website%20hero%20background%2C%20organic%20curves%20with%20negative%20space&width=1800&height=1000&seq=hero-bg-v3-m1n2&orientation=landscape"
          alt="CSSBuy Spreadsheet hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/18 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-6 py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-background-50 text-xs font-medium tracking-wide">GUIA COMPLETO 2026</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6">
          CSSBuy Spreadsheet<br />
          <span className="text-accent-300">Guia Completo</span>
        </h1>
        <p className="text-background-50/85 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Aprenda como usar, comparar e economizar com CSSBuy Spreadsheet. O guia definitivo para iniciantes e experientes no universo de agentes de compras da China.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            cssbuy spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-cart-line"></i>
          </a>
        </div>

        <div className="mt-12">
          <Link
            to="/artigo/o-que-e-cssbuy-spreadsheet"
            className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer"
          >
            Ler artigo completo
            <i className="ri-arrow-down-line animate-bounce"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}